import React, { Component } from 'react';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';

import FloatingLoginCard from '../../common-components/FloatingLoginCard';
import AppName from '../../common-components/AppName';
import FlexOne from '../../common-components/FlexOne';
import Link from '../../common-components/Link';
import AlertDialog from '../../common-components/AlertDialog';

import * as strings from '../../helpers/strings';

import * as forgetPasswordReducer from '../reducer';
import * as systemReducer from '../../system/reducer';

import * as forgetPasswordActionMgr from '../action-mgr';
import * as systemAction from '../../system/action-creator';

class ForgetPassword extends Component{

  constructor(){
    super();

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleSendOTP = this.handleSendOTP.bind(this);
    this.handleAlertClose = this.handleAlertClose.bind(this);
  }

  handleEmailChange(e){
    this.props.setEmail(e.target.value);
  }

  handleSendOTP(){
    const { email, requestOTP } = this.props;
    requestOTP(email);
  }

  handleAlertClose = () => this.props.toggleAlertDialog();

  render(){
    const { emailError, email, isRequestingOTP, alertMessage, openDialog } = this.props;

    return (
      <FloatingLoginCard 
        heading={<AppName/>} 
        subheading={strings.lblEnterEmail} 
        secondaryActions={[]}
        isLoading={isRequestingOTP}>
        <TextField
          fullWidth={true}
          label={strings.lblEmail}
          onChange={this.handleEmailChange}
          value={email}
          margin="normal"
          helperText={emailError}
          error={!!emailError}
        />
        <Grid container alignItems="center">
          <Link url="/login" text={strings.lblBack} />
          <FlexOne/>
          <Button variant={strings.btnRaised} color={strings.colorPrimary} onClick={this.handleSendOTP} disabled={!email}>{strings.lblSend}</Button>
        </Grid>
        <AlertDialog title={strings.lblForgetPassword} message={alertMessage} open={openDialog} onClose={this.handleAlertClose} />
      </FloatingLoginCard>
    );
  }
}

const mapStateToProps = state => ({
  email: forgetPasswordReducer.getEmail(state),
  emailError: forgetPasswordReducer.getEmailError(state),
  alertMessage: forgetPasswordReducer.getAlertMessage(state),
  openDialog: forgetPasswordReducer.getOpenDialog(state),
  isRequestingOTP: systemReducer.getIsRequestingOTP(state)
});

const mapActionsToFuncs = {
  requestOTP: systemAction.requestOTP,
  ...forgetPasswordActionMgr
};

export default connect(mapStateToProps, mapActionsToFuncs)(
  ForgetPassword
);